module.exports = __webpack_public_path__ + "static/media/lyft-logo.a292f3c8.svg";